import { Post } from "@/wp/types/client";
import { IndexedModuleData } from "../types/baseTypes";
import type { Module as ModuleType } from "../wp/types/acf-module-types";

type Module = ModuleType["module"][number];
export function getAllModuleData<T>(
  pageData: Post,
  moduleLayoutNames: Module["acf_fc_layout"][],
): { [key: number]: T } {
  const all_modules = pageData.acf
    ? Array.isArray(pageData?.acf?.module)
      ? pageData.acf.module
      : []
    : [];

  const active_modules: { [key: number]: T } = {};
  for (let i = 0; i < all_modules.length; i++) {
    if (moduleLayoutNames.includes(all_modules[i].acf_fc_layout)) {
      active_modules[i] = all_modules[i] as T;
    }
  }

  return active_modules;
}

export function getSingleModuleData<IndexModuleDataType>(
  indexedModuleData: IndexedModuleData<IndexModuleDataType>,
  index: number,
): IndexedModuleData<IndexModuleDataType>[number]["data"] {
  const moduleData = indexedModuleData.find((d) => d.index === index);
  if (!moduleData) {
    throw Error(`Module with index ${index} not found`);
  }
  return moduleData.data;
}
